import { Suspense, useEffect, useState } from "react";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";

// HOOKS
import { useConfig } from "../context/Config";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useQlik } from "../context/Qlik";

// PAGES
import BasketMix from "./BasketMix/BasketMix";
import Dashboard3 from "./Dashboard/Comportamento";
import Dashboard1 from "./Dashboard/CurvaAbcTopDown";
import Dashboard from "./Dashboard/Dashboard";
import Dashboard2 from "./Dashboard/Ranking";
import Detail from "./Detail/Detail";
import SelfService from "./SelfService/SelfService";

// COMPONENTS
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";

// ASSETS
import logo from "../assets/icons/logo.png";
// import logo from "../assets/icons/logo.svg";
import { I18nextProvider } from "react-i18next";
import MiddlewareRoute from "../components/MiddlewareRoute";
import i18n from "../i18n";
import "../style.scss";
import Auth from "./auth";
import Logout from "./auth/Logout";

function LayoutPage() {
  const { qlik, qlikConfig, setActualApp, switchOnDemand } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isSelfService, setIsSelfService] = useState(switchOnDemand);
  // App OnDemand
  const [appSelfService, setAppSelfService] = useState();

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);

      // Config App SelfService
      // id self-service 54423f30-0468-44d1-bfa5-cc74a4d1a989
      const qvfIdSelfService = process.env.REACT_APP_QVF_ID_ON_DEMAND;
      const tempAppSelfService = qlik.openApp(qvfIdSelfService, qlikConfig);
      setAppSelfService(tempAppSelfService);
    }
  }, [qlik]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [filterBarOpened, leftBarOpened]);

  useEffect(() => {
    // console.log("Proxima rota", switchOnDemand);
    setIsSelfService(switchOnDemand);
  }, [switchOnDemand]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      style={{ left: leftBarOpened && "224px" }}
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <LeftSideMenu app={app} config={config} logo={logo} />
        <Header />
        {isSelfService ? (
          // <FilterMenu
          //   app={appSelfService}
          //   filters={config.selfService?.cards[0] || {}}
          //   onDemand
          // />
          ""
        ) : (
          <FilterMenu app={app} filters={config.app?.filters || {}} />
        )}
        <Switch>
          <Route path="/auth" render={() => <Auth />} />
          <Route path="/redirect" render={() => <Logout />} />
          <Route
            path="/logout"
            render={() => <MiddlewareRoute component={<Logout />} publico />}
          />
          <Route
            path="/overview-executivo"
            exact
            render={() => (
              <MiddlewareRoute
                component={<Dashboard app={app} config={config} />}
                container
              />
            )}
          />
          <Route
            path="/strategic-vision/curva-abc-top-down"
            exact
            render={() => (
              <MiddlewareRoute
                component={<Dashboard1 app={app} config={config} />}
                container
              />
            )}
          />
          <Route
            path="/strategic-vision/ranking"
            exact
            render={() => (
              <MiddlewareRoute
                component={<Dashboard2 app={app} config={config} />}
                container
              />
            )}
          />
          <Route
            path="/strategic-vision/comportamento"
            exact
            render={() => (
              <MiddlewareRoute
                component={<Dashboard3 app={app} config={config} />}
                container
              />
            )}
          />
          <Route
            path="/oportunidades"
            exact
            render={() => (
              <MiddlewareRoute
                component={<BasketMix app={app} config={config} />}
                container
              />
            )}
          />
          <Route
            path="/self-service"
            exact
            render={() => (
              <MiddlewareRoute
                component={<SelfService app={appSelfService} config={config} />}
                container
              />
            )}
          />

          <Route exact path="/">
            <Redirect to="/overview-executivo" />
          </Route>
          <Route
            path="/detail"
            exact
            render={() => (
              <MiddlewareRoute
                component={<Detail app={app} config={config} />}
                container
              />
            )}
          />
        </Switch>
      </HashRouter>
    </div>
  );
}

export default function Layout() {
  return (
    <Suspense fallback={<AppLoader />}>
      <I18nextProvider i18n={i18n}>
        <LayoutPage />
      </I18nextProvider>
    </Suspense>
  );
}
